import { render } from "./ClientCard.vue?vue&type=template&id=27e18db6&scoped=true"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"

import "./ClientCard.vue?vue&type=style&index=0&id=27e18db6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e18db6"]])

export default __exports__